// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__70hrc"};